import {
  FormFieldComponent,
  FormFieldComponentProps,
} from "./form_fields/FormFieldComponent";
import {
  NewHardcodedDropdownFormComponent,
  NewHardcodedDropdownFormComponentProps,
} from "./form_fields/NewHardcodedDropdownFormComponent";

export const NewMultipleFormComponent = (props: {
  props: NewMultipleFormComponentProps;
  data: any;
  setData: any;
}) => {
  const type = Number(props.data.type) - 1;

  return (
    <>
      <NewHardcodedDropdownFormComponent
        props={props.props.typeSelector}
        data={props.data}
        setData={props.setData}
      />
      {props.props.formFields[type].map((field, index) => (
        <FormFieldComponent
          key={index}
          props={field}
          data={props.data}
          setData={props.setData}
        />
      ))}
    </>
  );
};

export type NewMultipleFormComponentProps = {
  formFields: FormFieldComponentProps[][];
  type: "multiple_form";
  typeSelector: NewHardcodedDropdownFormComponentProps;
};
